import { GetApp } from "../../App"
import { BlockField, BlockRow } from "../../Components/Block"
import { NumberInput } from "../../Components/Input"
import { IAlertThreshold } from "../../Types"

export interface DepthThresholdFieldsViewProps {
  namePrefix?: string;
  onEdited?: () => void;
  thresholds?: IAlertThreshold;
  // Defaults to true (ConditionsView's dense multi-field settings grid: narrow
  // centered inputs in a no-label row). The Depth Watch advice dialog sits in a
  // different visual context -- alongside AnchorMonitorView's own plain,
  // full-width number fields -- so it passes `compact={false}` to match.
  compact?: boolean;
}

// Depth limits read to one decimal (`5.0 m`), the precision they are alerted on and
// the way they have always been shown -- a bare `5` would suggest the field only
// takes whole meters.
function depthValue(meters: number | undefined): string | undefined {
  return meters == undefined ? undefined : meters.toFixed(1);
}

// Ship-wide depth-alert warning/alarm threshold inputs (#990). Shared by the NMEA
// Conditions settings page and the underway Depth Watch advice dialog, so both
// present and edit the exact same `<namePrefix>.depth.{warning,alarm}` fields with
// consistent labels. The unit is rendered inside the field by `NumberInput` itself
// (`5.0 m`), the presentation these fields have always had, rather than being
// repeated in the label (#1809).
export function DepthThresholdFieldsView({ namePrefix = "thresholds", onEdited, thresholds, compact = true }: DepthThresholdFieldsViewProps) {
  const app = GetApp();
  const t = app.getT("NMEAConfigurationView");
  return (
    <BlockRow className={compact ? "block-row-no_labels" : undefined}>
      <BlockField label={t("condition_depth_warning")} className={compact ? "label-left-0" : "block_field_small_12"}>
        <NumberInput format="float" unit="m" name={`${namePrefix}.depth.warning`} defaultValue={depthValue(thresholds?.warning)} className={compact ? "block_field_small_6 center" : "block_field_small_12 center"} onChange={onEdited} />
      </BlockField>
      <BlockField label={t("condition_depth_alarm")} className={compact ? "label-left-0" : "block_field_small_12"}>
        <NumberInput format="float" unit="m" name={`${namePrefix}.depth.alarm`} defaultValue={depthValue(thresholds?.alarm)} className={compact ? "block_field_small_6 center" : "block_field_small_12 center"} onChange={onEdited} />
      </BlockField>
    </BlockRow>
  );
}
